<template>
	<v-dialog :model-value="dialog" width="560" persistent>
		<v-card>
			<Confirmation :title="`Delete ${options.description}`"
				:button-options="buttonOptions"
				:styles="buttonStyles"
				@agree="deleteObject"
				@cancel="close">
				<v-card-text>
					<div class="text-body-2">
						Are you sure you want to delete the <span class="text-lowercase">
						{{ options.description }}</span>
						<span class="font-weight-bold">&nbsp;{{ options.object.Title }}</span>?
					</div>
				</v-card-text>
			</Confirmation>
		</v-card>
	</v-dialog>
</template>

<script>
import Confirmation from "@/components/dialogs/Confirmation.vue";

export default {
	name: "DeleteDialog",
	components: {Confirmation},

	props: ["dialog", "options"],

	emits: ["close"],

	data() {
		return {
			loading: false,
			buttonOptions: {
				agreeBtn: {
					enabled: true,
					message: "Delete"
				},
				cancelBtn: {
					enabled: true,
					message: "Cancel"
				}
			},
			buttonStyles: {
				messageClass: "text-center",
				actionButtonsContainerClass: "",
				agreeButton: {
					color: "error",
					variant: "flat"
				},
				cancelButton: {
					color: "error",
					variant: "text"
				}
			}
		}
	},

	methods: {
		deleteObject() {
			this.loading = true;

			this.$store.dispatch(this.options.action, this.options.objectId).then(response => {
				if (response.status === 200) {
					this.$store.commit(
						"SHOW_SUCCESS_NOTIFICATION",
						{message: `${this.options.description} successfully deleted!`}
					);
					if (typeof this.options.successCallback === "function") {
						this.options.successCallback(this.options.object);
					}
				}
				else {
					this.$store.commit(
						"SHOW_NOTIFICATION_WITH_TYPE",
						{message: `An error occurred when trying to delete the ${this.options.description.toLowerCase()}.`}
					);
				}

				if (typeof this.options.onComplete === "function") {
					this.options.onComplete(response);
				}
			}).finally(() => {
				this.loading = false
				this.close();
			});
		},

		close() {
			this.$emit("close");
		}
	}
};
</script>
